import useUserStore from "../stores/store";
import useOrderStore from "../stores/useOrderStore";
import useTableManagementStorage from "../stores/useTableManamentStore";
import { getOrderDefaultFilter } from "./store.helper";

export function clearAllSessionData() {
   useUserStore.getState().clearUser();
   useOrderStore.getState().setNewOrderId('');
   useOrderStore.getState().setShouldFetchOrderRecords(true);
   useOrderStore.getState().setShouldFetchDashboardOrders(true);
   useOrderStore.getState().setOrderRecordsFilter(getOrderDefaultFilter());
   useOrderStore.getState().setOrderRecords([]);
   useOrderStore.getState().setDashboardOrders([]);
   useOrderStore.getState().setOrderRecordsTotal(0);   
   useTableManagementStorage.getState().resetStore();
}
